import { Box, Grid2, Stack, Typography } from "@mui/material";
import BannerComponent from "../../Components/BannerComponent";
import qr from "../../assets/qr.jpeg";
import useScreenSize from "../../hooks/useScreenSize";
import ButtonComponent from "../../Components/ButtonComponent";
import ProofUploadForm from "./ProofUploadForm";
import { useState } from "react";

const Payments = () => {
  const { isLessThanMd } = useScreenSize();
  const [popUpOpen,setPopUpOpen]=useState(false)

  const handleOpenPopUp=()=>{
    setPopUpOpen(true)
  }

  const handleClosePopUp = ()=>{
    setPopUpOpen(false)
  }

  return (
    <>
    <Box className="container">
      <BannerComponent
        sectionTitle="Payments"
        title="Pay easily via bank details or QR code."
      />
      <Box className="container section-divide">
        {isLessThanMd && (
          <Grid2 size={{ xs: 12, md: 6 }} sx={{ marginBottom: "20px" }}>
            <Stack sx={{ maxWidth: "80%", margin: "auto" }}>
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, textAlign: "center" }}
              >
                Scan and Pay
              </Typography>

              <img src={qr} alt="qr" width={400} style={{ margin: "auto" }} />
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, textAlign: "center" }}
              >
                tresormicrofinance@ybl
              </Typography>
            </Stack>
          </Grid2>
        )}
        <Grid2 container>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Stack gap={2} sx={{ maxWidth: "80%", margin: "auto" }}>
              <Box sx={{display:'flex',justifyContent:"space-between",alignItems:"center"}}>

              <Typography
                variant="h4"
                sx={{ fontWeight: 700, textAlign: "center" }}
                >
                Bank Details
              </Typography>
              <ButtonComponent type="button" value="Upload Proof" onClick={handleOpenPopUp}/>
                </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ fontWeight: 600 }}>
                  Account Number:
                </Typography>
                <Typography>018288700000342</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ fontWeight: 600 }}>IFSC Code:</Typography>
                <Typography>YESB0000182</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ fontWeight: 600 }}>Bank Name:</Typography>
                <Typography>Yes Bank</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ fontWeight: 600 }}>Account Type:</Typography>
                <Typography>Current</Typography>
              </Box>
            </Stack>
          </Grid2>
          {!isLessThanMd && (
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Stack sx={{ maxWidth: "80%", margin: "auto" }}>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 700, textAlign: "center" }}
                >
                  Scan and Pay
                </Typography>

                <img src={qr} alt="qr" width={400} style={{ margin: "auto" }} />
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, textAlign: "center" }}
                >
                  tresormicrofinance@ybl
                </Typography>
              </Stack>
            </Grid2>
          )}
        </Grid2>
      </Box>
    </Box>
      <ProofUploadForm open={popUpOpen} onClose={handleClosePopUp} />
    </>
  );
};

export default Payments;
